// Nav flotante que aparece SOBRE la capa seleccionada (CanvasStage lo posiciona).
// Acciones rápidas: duplicar, abrir el panel de Capas, eliminar. Con tooltips.
// El orden/z de capas fino vive en el panel de Capas (botón del medio).

import { Copy, Layers, Trash2 } from 'lucide-react';
import { Tooltip } from '../panels/Tooltip';

interface Props {
  onDuplicate: () => void;
  onOpenLayers: () => void;
  onRemove: () => void;
  /** Tooltips hacia arriba o abajo según de qué lado del elemento esté el nav. */
  tooltipSide?: 'top' | 'bottom';
}

const BTN =
  'w-8 h-8 rounded-md flex items-center justify-center text-neutral-600 hover:bg-neutral-100 active:scale-95 transition';

export function FloatingToolbar({ onDuplicate, onOpenLayers, onRemove, tooltipSide = 'top' }: Props) {
  return (
    <div className="eg-flotante inline-flex items-center gap-0.5 px-1.5 py-1 bg-surface-card border border-neutral-300 rounded-full shadow-lg ring-1 ring-black/[0.06]">
      <Tooltip label="Duplicar" side={tooltipSide}>
        <button type="button" className={BTN} onClick={onDuplicate} aria-label="Duplicar">
          <Copy className="w-[18px] h-[18px]" />
        </button>
      </Tooltip>
      <Tooltip label="Capas" side={tooltipSide}>
        <button type="button" className={BTN} onClick={onOpenLayers} aria-label="Capas">
          <Layers className="w-[18px] h-[18px]" />
        </button>
      </Tooltip>
      <div className="w-px h-5 bg-neutral-200 mx-0.5" />
      <Tooltip label="Eliminar" side={tooltipSide}>
        <button
          type="button"
          className={`${BTN} hover:text-error hover:bg-error-soft`}
          onClick={onRemove}
          aria-label="Eliminar"
        >
          <Trash2 className="w-[18px] h-[18px]" />
        </button>
      </Tooltip>
    </div>
  );
}
